var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-summary-payment"},[(_vm.dataResponse != {})?_c('data-summary-payment',{attrs:{"data-response":_vm.dataResponse,"products":_vm.products}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }